var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.606,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.555 13.602v11.617l11.052 3.591v-18.8zm-27.543 2.55a3.261 3.261 0 103.26 3.26 3.265 3.265 0 00-3.26-3.261zm23.812-9.327H21.389V3.341a2.274 2.274 0 00-2.276-2.278H6.298v11.982h4.4v16.682a2.271 2.271 0 002.275 2.274h31.85a2.275 2.275 0 002.278-2.274V9.096a2.274 2.274 0 00-2.277-2.272zm-8.035 18.126H21.012a5.552 5.552 0 114.464-2.277h6.844a5.531 5.531 0 114.469 2.277zm0-8.8a3.261 3.261 0 103.259 3.26 3.27 3.27 0 00-3.259-3.26zM6.299.911A.911.911 0 005.386 0h-2.2a.909.909 0 00-.911.911v.151h4.021zM2.278 13.198a.914.914 0 00.911.912h2.2a.915.915 0 00.913-.912v-.154H2.281zM.001 3.34v7.43a2.274 2.274 0 002.277 2.274V1.062A2.277 2.277 0 00.004 3.34z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.de978a7f318b17458d4144011fb7d846.svg";
export { ForwardRef as ReactComponent };